import { Injectable } from '@angular/core';
import { DealerServiceDetailsViewModel } from '../business-entities/dealer-service-details-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { SelectListItemViewModel } from '../business-entities/select-list-item-view-model';
import { DealerServiceDataService } from '../data-services/dealer-service-data.service';
import { DealerServiceDetailsListViewModel } from './../business-entities/dealer-service-details-list-view-model';
import { DealerServiceRequestModel, DealerServiceViewModel } from './../business-entities/dealer-service-view-model';

@Injectable({
    providedIn: 'root'
})

export class DealerServiceBusinessService {

    dealerServiceDetails: DealerServiceViewModel;
    dealerId: string = '';
    languageCode: string = '';
    isEdit: boolean = false;
    dealerList:Array<SelectListItemViewModel>;
    selectedDealer:string='';
    constructor(private dealerServiceDataService: DealerServiceDataService) { }

    async getDealerServiceList(dealerServiceRequestModel:DealerServiceRequestModel) {
        let dealerServiceDetailsList: DealerServiceDetailsListViewModel;
        await this.dealerServiceDataService
        .getDealerServiceList(dealerServiceRequestModel)
            .then(
                (res: GenericResponse<DealerServiceDetailsListViewModel>) => {
                    dealerServiceDetailsList = res.responseObject;
                }
            );
        return dealerServiceDetailsList;
    }

    async getDealerServiceDetails(dealerServiceId: number, language:string) {
        let response: DealerServiceDetailsViewModel;
        await this.dealerServiceDataService
            .getDealerServiceDetails(dealerServiceId,language)
            .then(
                (res: GenericResponse<DealerServiceDetailsViewModel>) => {
                    response = res.responseObject;
                }
            );
        return response;
    }

    addDealerServices(dealerServiceViewModel: DealerServiceViewModel): Promise<GenericResponse<any>> {
        return this.dealerServiceDataService.addDealerServices(dealerServiceViewModel);
    }

    editDealerServices(dealerServiceViewModel: DealerServiceViewModel): Promise<GenericResponse<any>> {
        return this.dealerServiceDataService.editDealerServices(dealerServiceViewModel);
    }

    deleteDealerService(id: number) {
        return this.dealerServiceDataService.deleteDealerService(id);
    }

    getServiceCategory() {
        return this.dealerServiceDataService.getServiceCategory();
    }
    GetDealerServiceTimeDetails(DealerServiceId: number) {
        return this.dealerServiceDataService.GetDealerServiceTimeDetails(DealerServiceId);
    }
}